__turbopack_context__.v({
  "businessRequirements": "NumberedList-module-scss-module__XW4YnW__businessRequirements",
  "businessRequirements__description": "NumberedList-module-scss-module__XW4YnW__businessRequirements__description",
  "businessRequirements__item": "NumberedList-module-scss-module__XW4YnW__businessRequirements__item",
  "businessRequirements__list": "NumberedList-module-scss-module__XW4YnW__businessRequirements__list",
  "businessRequirements__title": "NumberedList-module-scss-module__XW4YnW__businessRequirements__title",
});
